import React, { PropTypes } from 'react';

function DotPoints(props) {
  let classNames = props.className;
  return (
    <ul className={ classNames }>
      {props.array.map((text) => {
        return (
          <li key={ text }>{ text }</li>
        )
      })}
    </ul>
  )
}

DotPoints.propTypes = {
  array: PropTypes.array.isRequired
}

export default DotPoints;



/** WEBPACK FOOTER **
 ** ./src/components/presentational/DotPoints.jsx
 **/